var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.09 56.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.17;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.62,20.44c-9-.86-21.68,4.85-23.14,14.7-1.83,12.41,6.91,18.42,17.7,20.18a1.11,1.11,0,0,0,.34-2.2c-8.78-1.46-16.23-6-15.72-16,.55-10.75,14.71-16.33,23.85-13.22C42,26.74,45.83,35.08,44.12,43.28c-2,9.38-8.81,10.26-16.73,10.83-1.13.08-1.2,2,0,2,9.75.54,17.29-1.72,19.51-12.44S42.12,21.54,30.62,20.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.46,11.47C9.75,8.85,6.79,8.67,4,9.19a3.59,3.59,0,0,0-1.47.34l-1,.3a1.13,1.13,0,0,0-.68,1.46A7.72,7.72,0,0,0,0,15.57c.45,4.26,4.45,7.14,8.47,5.3A6.36,6.36,0,0,0,11.46,11.47Zm-2.88,5.9a3.27,3.27,0,0,1-5.67-1.45,5.62,5.62,0,0,1,0-3,2.45,2.45,0,0,1,.42-1,9.38,9.38,0,0,1,4.33.15C9.75,12.89,10.12,15.88,8.58,17.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.06,3.56C33.67.4,28.52-1.34,25.92,1.27a1.43,1.43,0,0,0-.15.22,5.55,5.55,0,0,0-3.68,6.28c.59,4.14,3.83,7.11,8,5.76S36.93,7.79,35.06,3.56Zm-5.74,7.17c-2.35.8-3.79-.71-4.41-2.93-.7-2.54.89-4.68,3.54-4.41a1,1,0,0,0,1-.48,4.13,4.13,0,0,1,3,2.22C33.34,7.64,31.65,9.94,29.32,10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.22,17.24a6.23,6.23,0,0,0-2.8-5.12A5.35,5.35,0,0,0,48,11.43c-2.15-2.09-5.05,1.93-5.5,4.08-.69,3.31.12,8,4.44,7.67C50.16,23,54.36,20.88,54.22,17.24Zm-6.86,2.93c-2,.41-2.41-1.29-2.33-3A8.09,8.09,0,0,1,45.35,15a6.06,6.06,0,0,1,.72-1.28,1.24,1.24,0,0,0,1.78.45c.67-.39,2.08.38,2.51.83a3.57,3.57,0,0,1,.85,2.81C50.8,19.18,48.6,19.92,47.36,20.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.09,35.23A6,6,0,0,0,61,30.66c-1.67-1.52-3.54-1.68-5.68-1.32l-.13.05c-1.53.1-3.11,1.85-3.62,3.42a5.64,5.64,0,0,0,4.12,7.41C58.9,40.89,63,38.85,63.09,35.23Zm-5.88,2.28A2.91,2.91,0,0,1,53.92,35c0-.45.46-2.8,1.14-3.21a.85.85,0,0,0,.17,0l.32,0,.09.07a1,1,0,0,0,1.47.1A3.42,3.42,0,0,1,60,34.09C60.85,36.07,59,37.37,57.21,37.51Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.c3f1eaf291384a848dfdd5907e83a817.svg";
export { ForwardRef as ReactComponent };